<span><i [attr.data-icon]="iconImage" class="icon {{ iconType }}"></i></span>
